import {createAction} from '@packages/utilities/create-action';
import type {PageRecordType} from '@packages/systems/core/records/PageRecord';
import {
  PAGE_FOLDER_SAVED,
  PAGE_SAVED_REMOTELY,
  BRANCH_CREATE_SUCCEEDED,
  PAGE_DELETED_SUCCESS,
} from '@packages/systems/designer/actions';

/**
 * Action creator for PAGE_SAVED_REMOTELY that supports both remote and local contexts.
 * TODO: [COLLAB-5787] Replace with middleware listener pattern and canonicalize the action payload to match PAGE_SAVED
 */
export const pageSavedRemotely = createAction<
  typeof PAGE_SAVED_REMOTELY,
  {
    fields: PageRecordType;
    pageId: string;
  }
>(PAGE_SAVED_REMOTELY);

export const pageFolderSaved = createAction<
  typeof PAGE_FOLDER_SAVED,
  {
    folder: PageRecordType;
  }
>(PAGE_FOLDER_SAVED);

export const pageDeletedSuccess = createAction<
  typeof PAGE_DELETED_SUCCESS,
  {
    id: string;
  }
>(PAGE_DELETED_SUCCESS);

export const pageBranched = createAction<
  typeof BRANCH_CREATE_SUCCEEDED,
  {
    page: PageRecordType;
    basePageId: string;
    userId?: string;
  }
>(BRANCH_CREATE_SUCCEEDED);
